/**
 * @voltxampere/presets — Digital XOR gate demo (Sprint 50-5)
 *
 * 2-input XOR (exclusive-OR) gate. Output is HIGH only when inputs
 * differ. With one input HIGH (5V) and the other LOW (0V), output
 * goes HIGH. Used in parity generators, comparators, half-adders.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { makeCircuit, makeNet, makeComponent } from "../_builders.js";
export const digitalXorGate = {
    id: "digital-xor-gate",
    name: { tr: "Dijital ÖZEL-VEYA Kapısı", en: "Digital XOR Gate" },
    category: "digital",
    difficulty: 1,
    description: {
        tr: "2-girişli ÖZEL-VEYA kapısı. Girişler farklı ise çıkış HIGH.",
        en: "2-input XOR gate. Output HIGH when inputs differ.",
    },
    circuit: makeCircuit({
        slot: 1,
        name: "Digital XOR Gate",
        description: "2-input XOR with differing inputs",
        nets: [
            makeNet({ name: "gnd", isGround: true }),
            makeNet({ name: "in1" }),
            makeNet({ name: "in2" }),
            makeNet({ name: "out" }),
        ],
        components: [
            makeComponent({
                id: "V_IN1",
                type: "voltage-source",
                params: { voltage: 5 },
                terminals: { pos: "net_in1", neg: "net_gnd" },
                label: "V_IN1",
                position: { x: -160, y: -60 },
                rotation: 0,
            }),
            makeComponent({
                id: "V_IN2",
                type: "voltage-source",
                params: { voltage: 0 },
                terminals: { pos: "net_in2", neg: "net_gnd" },
                label: "V_IN2",
                position: { x: -160, y: 60 },
                rotation: 0,
            }),
            makeComponent({
                id: "U1",
                type: "digital-gate",
                params: { gateFunction: "XOR", vHigh: 5, vLow: 0, threshold: 2.5 },
                terminals: { in1: "net_in1", in2: "net_in2", out: "net_out" },
                label: "U1",
                position: { x: 0, y: 0 },
                rotation: 0,
            }),
            makeComponent({
                id: "GND1",
                type: "ground",
                params: {},
                terminals: { p: "net_gnd" },
                position: { x: -160, y: 80 },
                rotation: 0,
            }),
        ],
        wires: [],
    }),
    expectedValues: [
        {
            node: "out",
            analysis: "dc",
            value: 5,
            tolerance: 0.001,
            unit: "V",
        },
    ],
    learningGoals: [
        {
            tr: "ÖZEL-VEYA doğruluk tablosu: girişler eşit ise 0, farklı ise 1.",
            en: "XOR truth table: 0 when inputs equal, 1 when they differ.",
        },
        {
            tr: "Yarım toplayıcı (half-adder) ana yapı taşıdır.",
            en: "Building block of the half-adder.",
        },
    ],
    references: ["Sedra/Smith, Microelectronic Circuits, Ch. 14"],
};
//# sourceMappingURL=digital-xor-gate.js.map